"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectablePiece = SelectablePiece;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const clickPiece_1 = require("../hooks/clickPiece");
const Piece_1 = require("./Piece");
const useStyles = (0, react_jss_1.createUseStyles)({
    selectablePiece: {
        width: "100%",
        height: "100%",
    },
    selected: {
        boxSizing: "border-box",
        border: "2px solid #ff5200",
    },
});
function SelectablePiece({ piece }) {
    const styles = useStyles();
    const onClickPiece = (0, clickPiece_1.useOnClickPiece)();
    const selectedPieceId = (0, react_redux_1.useSelector)((state) => state.game.ui.selectedPieceId);
    const onClick = () => {
        onClickPiece(piece.id);
    };
    const isSelected = selectedPieceId === piece.id;
    const className = (0, classnames_1.default)(styles.selectablePiece, {
        [styles.selected]: isSelected,
    });
    return (React.createElement("div", { className: className },
        React.createElement(Piece_1.Piece, { piece: piece, onClick: onClick })));
}
